import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import CartRepository from "../../../repository/CartRepository";
import produceClone from "../../../helper/produceClone";
import System from "src/helper/system";
import Cookies from "js-cookie";

const initialState = {
    CART_COUNT: Cookies.get(System.storageName.CART_COUNT) ? Cookies.get(System.storageName.CART_COUNT) : 0,
    CART_DATA: {},
    CART_LOADER_DATA_OBJECT: {},
    WEB_ORDER_ID: false,
    CART_BEFORE_TO_SEND_SERVER: {},
    CART_PRICE_BEFORE_TO_SEND_SERVER: {},
    ADD_CART_DATA: false,
    CART_SUB_TOTAL: 0,
    VALIDATE_CART: {},
    SHIPPING_SCHEDULE_DATA: [],
    CART_ERRORS: {},
    CART_TAX_TARIFF: {},
    mergeCart: {},
    COMPLIANCE_DATA: {}
};


export const getCartCount = createAsyncThunk('cart_count', async (params) => {
    return await new CartRepository().fetchCartCount(params)
});

export const getValidateCartFromServer = createAsyncThunk('get_Validate_Cart_From_Server', async (param) => {
    return await new CartRepository().getValidateCartFromServer(param)
});

export const getCartTax = createAsyncThunk('get_Cart_Tax', async (param) => {
    return await new CartRepository().getCartTax(param)
});

export const mergeGuestCartItems = createAsyncThunk('merge_Guest_CartItems', async () => {
    return await new CartRepository().mergeGuestCartItems()
});

export const fetchCartTax = createAsyncThunk('fetch_Cart_Tax', async (params) => {
    return await new CartRepository().fetchCartTax(params)
});

export const getComplianceData = createAsyncThunk('get_compliance_data', async (params) => {
    return await new CartRepository().getComplianceData(params)
});

const slice = createSlice({
    name: "cart",
    initialState: initialState,
    reducers: {
        SET_CART_DATA: {
            reducer: (state, action) => {
                state.CART_COUNT = action.payload?.CART_DATA?.length;
                state.CART_DATA = {}
                let total = 0
                if (action.payload.CART_DATA && action.payload.CART_DATA.length > 0) {
                    action.payload.CART_DATA.map((v) => {
                        total = total + v.subtotal
                        state.CART_DATA[v.ItemNumber] = v;
                    })
                    state.CART_SUB_TOTAL = total;
                } else {
                    state.CART_SUB_TOTAL = 0
                }
                Cookies.set(System.storageName.CART_COUNT, action.payload?.CART_DATA?.length || 0)
            },
        },
        SET_CART_LOADER_DATA_OBJECT: {
            reducer: (state, action) => {
                if (action?.payload) {
                    state.CART_LOADER_DATA_OBJECT = {}
                    state.CART_LOADER_DATA_OBJECT[action.payload.ItemNumber] = { ...action.payload };
                } else {
                    state.CART_LOADER_DATA_OBJECT = {}
                }
            },
        },
        SET_CART_WEB_ORDER_ID: {
            reducer: (state, action) => {
                state.WEB_ORDER_ID = action.payload.WEB_ORDER_ID
            },
        },

        SET_CART_BEFORE_TO_SEND_SERVER_SINGLE_PRODUCT: {
            reducer: (state, action) => {
                const a = produceClone(action.payload.CART_DATA);
                state.CART_BEFORE_TO_SEND_SERVER[a.ItemNumber] = { ...state.CART_BEFORE_TO_SEND_SERVER[a.ItemNumber], ...a }
            },
        },
        SET_CART_PRICE_BEFORE_TO_SEND_SERVER_SINGLE_PRODUCT: {
            reducer: (state, action) => {
                /* Payload will have very minimal data - use CART_BEFORE_TO_SEND_SERVER
                this data may merge with CART_BEFORE_TO_SEND_SERVER in future before sending to server
                * */
                if (action.payload.CART_DATA.unitPrice !== undefined) {
                    state.CART_PRICE_BEFORE_TO_SEND_SERVER[action.payload.CART_DATA.ItemNumber] = action.payload.CART_DATA
                }
            },
        },
        SET_ADD_CART_DATA: {
            reducer: (state, action) => {
                state.ADD_CART_DATA = action.payload;
            },
        },
        set_cart_tax: {
            reducer: (state, action) => {
                const data = {
                    tax: 0,
                    tariff: 0
                }
                if (action.payload.data) {
                    data.tax = Number(action.payload.data.tax) || 0;
                    data.tariff = Number(action.payload.data.tariff) || 0;
                }
                state.CART_TAX_TARIFF = data;
            },
        },
        SET_CLEAR_VALIDATE_CART: {
            reducer: (state, action) => {
                state.VALIDATE_CART = {}
            },
        },
    },
    extraReducers: {
        [getCartCount.fulfilled]: (state, { payload }) => {
            state.CART_COUNT = payload.data.count
            Cookies.set(System.storageName.CART_COUNT, payload.data.count)
            return state;
        },
        [getValidateCartFromServer.fulfilled]: (state, { payload }) => {
            state.VALIDATE_CART = payload
            return state;
        },
        [fetchCartTax.fulfilled]: (state, { payload }) => {
            state.CART_TAX_TARIFF = payload;
            return state;
        },
        [fetchCartTax.rejected]: (state, { payload }) => {
            state.CART_TAX_TARIFF = payload;
            return state;
        },
        [getComplianceData.fulfilled]: (state, { payload }) => {
            state.COMPLIANCE_DATA = payload;
            return state;
        },
        [getComplianceData.rejected]: (state, { payload }) => {
            state.COMPLIANCE_DATA = payload;
            return state;
        },
        [mergeGuestCartItems.fulfilled]: (state, { payload }) => {
            state.mergeCart = payload
            return state;
        },
    },
});


export const {
    SET_CART_DATA,
    SET_CART_LOADER_DATA_OBJECT,
    SET_CART_WEB_ORDER_ID,
    SET_CART_BEFORE_TO_SEND_SERVER_SINGLE_PRODUCT,
    SET_CART_PRICE_BEFORE_TO_SEND_SERVER_SINGLE_PRODUCT,
    SET_CART_DATA_ERROR,
    SET_ADD_CART_DATA,
    set_cart_tax,
    SET_CLEAR_VALIDATE_CART
} = slice.actions;

export default slice.reducer;
